<template lang="pug">
  #adminaccess
    v-container(fluid)
      LoseAccesDialog(ref="loseAccesModal")
      v-row.white-background.mt-4.mb-4(row wrap)
        v-col.mt-5.mb-3.border-list(xs=12 sm=3)
          .list-title.dark-text.mb-3 Listado de usuarios
          v-row.user-list
            v-col.user.py-2(xs=12 v-if="!userList.length > 0")
              p.field-title.mb-0.ml-1 Aún no hay usuarios registrados
            v-col.user.py-2(xs=12 v-if="userList.length > 0" v-for="(user, index) in userList" :key="index" @click="selectUser(user)" :class="{ 'toggle-user': user.clicked }")
              p.field-title.bold.mb-0.ml-1 {{user.name}}
              p.field-title.mb-0.ml-1 {{`<${user.email}>`}}
          v-row.new-user.mt-2
            v-btn.white-btn.save.bolder(@click="addUser()") Nuevo usuario
        v-col.mt-3.info-container(xs=12 sm=9)
          v-row(d-flex v-if="!newUser && userPermissions.deleteUser")
            v-col(xs=12)
              p.delete(@click="deleteUser()") Eliminar usuario &nbsp;
                span
                  font-awesome-icon(icon="trash-alt" size="lg")
          v-row.profile.mt-3.mb-4
            v-col(xs=12 sm=3)
              .avatar.mt-5
                .avatar-inside
                  span.initials {{ getUserInitials() }}
              //- v-tooltip(light top)
              //-   template(v-slot:activator="{ on }")
              //-     font-awesome-icon.edit(icon="times" @click="deleteFoto" v-on="on")
              //-   span Borrar foto
              //- img(width="100%" v-if="selectedUser.profileImg && selectedUser.profileImg.url" title="Cambiar imagen" fluid alt="profile img" :src="foto"  @click="pickFile")
              //- img(width="100%" v-if="!(selectedUser.profileImg && selectedUser.profileImg.url)" title="Cambiar imagen" fluid alt="profile img" src="static/upload-icon.png"  @click="pickFile")
              //- input(
              //-   type="file"
              //-   style="display: none"
              //-   ref="image"
              //-   accept="image/*"
              //-   @change="uploadUserProfileImg"
              //- )
            v-col.pl-4(xs=12 sm=9)
              // Nombre
              .user-name.field-title.my-1(v-if="!editName" @click="editField('name')") {{selectedUser.name}}
                v-tooltip(light top)
                  template(v-slot:activator="{ on }")
                    font-awesome-icon.edit(icon="pen" v-on="on")
                  span Editar nombre

              v-form.mb-3(v-if="editName")
                label.label-title(for="userName") Nombre completo:
                v-row(flex)
                  input.access-form-control(name="userName", v-model="selectedUser.name")
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="save" @click="saveField('name')" v-on="on")
                    span Guardar cambios
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="times" @click="cancelEdit('name')" v-on="on")
                    span Cancelar cambios

              // Correo
              .small-font.field-title.my-1(v-if="!editMail" @click="editField('mail')") {{selectedUser.email}}
                v-tooltip(light top)
                  template(v-slot:activator="{ on }")
                    font-awesome-icon.edit(icon="pen" v-on="on")
                  span Editar correo

              v-form.my-2(v-if="editMail")
                label.label-title(for="userMail") Correo de acceso:
                v-row(flex)
                  input.access-form-control(
                    type="email",
                    required,
                    name="userMail",
                    v-model="selectedUser.email",
                    value="selectedUser.email")
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="save" @click="saveField('mail')" v-on="on")
                    span Guardar cambios
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="times" @click="cancelEdit('mail')" v-on="on")
                    span Cancelar cambios

              // Rol
              .small-font.field-title.my-1(v-if="!editRole" @click="editField('role')") {{selectedUser.role}}
                v-tooltip(light top)
                  template(v-slot:activator="{ on }")
                    font-awesome-icon.edit(icon="pen" v-on="on")
                  span Editar rol

              v-form.mt-3(v-if="editRole")
                label.label-title(for="userRole") Tipo de usuario:
                v-row(flex)
                  v-select.select.pt-0(name="userRole", v-model="selectedUser.role" :items="roleOptions")
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="save" @click="saveField('role')" v-on="on")
                    span Guardar cambios
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="times" @click="cancelEdit('role')" v-on="on")
                    span Cancelar cambios

              // Contraseña
              p.pswd.main-text.my-1(@click="editField('password')" v-if="!editPassword") Editar contraseña
              v-form.mt-3(v-if="editPassword")
                v-row.align-end(flex)
                  v-col.form-group(xs=5)
                    label.label-title(for="userPaswd") Nueva contraseña:
                    input.access-form-control(
                      type="password"
                      required,
                      name="userPaswd",
                      v-model="selectedUser.password",
                      value="selectedUser.password"
                    )
                  v-col.form-group.pl-2(xs=5)
                    label.label-title(for="pswConfirm") Confirmar contraseña:
                    input.access-form-control(
                      type="password"
                      required,
                      name="pswConfirm",
                      v-model="confirmPassword",
                      value="confirmPassword"
                    )
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="save" @click="updatePassword()" v-on="on")
                    span Guardar cambios
                  v-tooltip(light top v-if="!newUser")
                    template(v-slot:activator="{ on }")
                      font-awesome-icon.edit.ml-2(icon="times" @click="cancelEdit('password')" v-on="on")
                    span Cancelar cambios

          //hr(v-if="!newUser && this.currentUser.permission.createUser")
          v-col.permissions-container(xs12 v-if="!newUser && currentUser.permission && currentUser.permission.createUser && currentUser.permission.updatePermissions")
            v-row
              v-col.mt-3(xs=12)
                .permissions.light.dark-accent-text Permisos:
                // p.access-subtitle Selecciona cuáles variables puede ver el usuario:
            v-row.mt-3
              v-form
                v-row
                  v-col.checkbox-form-group(xs=12 md=3 v-for="permission in permissionOptions" :key="permission.slug")
                    v-checkbox.form-check-input(color="#4361ee" :label="permission.name" v-model="selectedUser.permission[permission.slug]" @change="saveField('permission')" )

          v-row.mt-3.end-row(v-if="newUser")
            v-btn.save.main-color-button.bold.py-1.px-3.my-5(@click="createUser()") Crear usuario

</template>
<script>
/**
 * @todo:
 * 1. Upload img -> selectedUser.profileImg
 * 2. Get permissions and role options from api
 */
import LoseAccesDialog from "./LoseAccesDialog.vue";

export default {
  name: "AdminAccess",
  components: {
    LoseAccesDialog
  },
  data() {
    return {
      userInitials: "",
      permissionOptions: [
        {
          slug: "createUser",
          name: "Crear usuario"
        },
        {
          slug: "deleteUser",
          name: "Eliminar usuario"
        },
        {
          slug: "createReports",
          name: "Crear casos"
        },
        {
          slug: "updateReports",
          name: "Editar relatoria"
        },
        {
          slug: "deleteReports",
          name: "Eliminar casos"
        },
        {
          slug: "viewReports",
          name: "Ver casos"
        },
        {
          slug: "updatePermissions",
          name: "Modificar Permisos"
        },
        {
          slug: "updateQuestionnaire",
          name: "Editar datos socioecómicos"
        },
        {
          slug: "createOption",
          name: "Crear opción en lista desplegable "
        },
        {
          slug: "createTags",
          name: "Gestionar etiquetas"
        }
      ],
      confirmPassword: "",
      dialog: false,
      editRole: false,
      editName: false,
      editMail: false,
      editPassword: false,
      newUser: false,
      originalUser: {},
      roleOptions: ["Administración", "Capturista", "Visitante"],
      currentUser: {},
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    userList() {
      return this.$store.getters.userList;
    },
    foto: {
      get() {
        return `${this.$store.state.userEdit.profileImg.url}?${new Date().getTime()}`;
      },
      set(value) {
        this.$store.state.userEdit.profileImg = value;
      }
    },
    selectedUser() {
      return this.$store.getters.userEdit;
    },
    userPassword: {
      get() {
        return this.$store.state.userEdit["password"];
      },
      set(value) {
        this.$store.state.userEdit.password = value;
      }
    },
    userEmail: {
      get() {
        return this.$store.state.userEdit["email"];
      },
      set(value) {
        this.$store.state.userEdit.email = value;
      }
    },
    userRole: {
      get() {
        return this.$store.state.userEdit["role"];
      },
      set(value) {
        this.$store.state.userEdit.role = value;
      }
    },
    userProfileImg: {
      get() {
        return this.$store.state.userEdit["profileImg"];
      },
      set(value) {
        this.$store.state.userEdit.profileImg = value;
      }
    }
  },
  methods: {
    addUser() {
      this.selectUser({});
      this.editName = true;
      this.editRole = true;
      this.editMail = true;
      this.editPassword = true;
      this.newUser = true;
      this.confirmPassword = "";
    },
    selectUser(user) {
      this.$store.commit("setUserEdit", user);
      this.originalUser = Object.assign({}, user);
      this.editName = false;
      this.editRole = false;
      this.editMail = false;
      this.editPassword = false;
      this.newUser = false;

      this.userList.forEach(function(entry) {
        entry.clicked = false;
      });
      user.clicked = true;
    },
    deleteUser() {
      // console.log('deleteUser', this.selectedUser);
      this.$store.commit("setIsLoadingState", true);
      this.$store
        .dispatch("deleteUser")
        .then(response => {
          this.$store.commit("setIsLoadingState", false);
          this.$store.commit("setUserEdit", this.userList[0]);
          this.originalUser = Object.assign({}, this.selectedUser);
          this.$store.state.deleteUsersAsyncStatusCode = response.status;
          this.$store.commit("setShowNotification", {
            type: "success",
            title: "Contacto eliminado",
            text: "El usuario se eliminó con éxito"
          });
          this.getUserList();
        })
        .catch(error => {
          // console.log(error);
          this.$store.commit("setIsLoadingState", false);
          this.$store.state.deleteUsersAsyncStatusCode = error.status;
          this.$store.commit("setShowNotification", {
            type: "error",
            title: "Ocurrió un error",
            text: "Por favor intenta de nuevo más tarde"
          });
        });
    },
    editField(field) {
      //console.log('edit ',field);
      if (field == "name") {
        this.editName = true;
      } else if (field == "role") {
        this.editRole = true;
      } else if (field == "mail") {
        this.editMail = true;
      } else if (field == "password") {
        this.editPassword = true;
        this.selectedUser.password = "";
        this.confirmPassword = "";
      }
    },
    cancelEdit(field) {
      //console.log('edit ',field);
      this.$store.commit("setUserEdit", this.originalUser);
      if (field == "name") {
        this.editName = false;
      } else if (field == "role") {
        this.editRole = false;
      } else if (field == "mail") {
        this.editMail = false;
      } else if (field == "password") {
        this.editPassword = false;
      }
    },
    createUser() {
      if (
        this.selectedUser.name === "" ||
        typeof this.selectedUser.name === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un nombre"
        });
      } else if (
        this.selectedUser.role === "" ||
        typeof this.selectedUser.role === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha seleccionado un rol"
        });
      } else if (
        this.selectedUser.email === "" ||
        typeof this.selectedUser.email === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un correo"
        });
      } else if (
        this.selectedUser.password === "" ||
        typeof this.selectedUser.password === "undefined" ||
        this.selectedUser.password.length <= 6
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado una contraseña de al menos 6 caracteres"
        });
      } else if (this.confirmPassword !== this.selectedUser.password) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "Las contraseñas no coinciden"
        });
      } else {
        this.$store.commit("setIsLoadingState", true);
        this.$store
          .dispatch("createUser")
          .then(response => {
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("setUserEdit", response.data.user);
            this.originalUser = Object.assign({}, this.selectedUser);

            this.editRole = false;
            this.editName = false;
            this.editMail = false;
            this.editPassword = false;
            this.newUser = false;

            this.$store.state.createUsersAsyncStatusCode = response.status;
            this.$store.state.createUsersAsyncData = response.data;
            this.$store.state.createUsersAsyncPending = false;

            this.$store.commit("setShowNotification", {
              type: "success",
              title: "Contacto actualizado",
              text: "La información se guardó con éxito"
            });
            this.getUserList();
          })
          .catch(error => {
            // console.log(error);
            this.$store.commit("setIsLoadingState", false);
            this.$store.state.createUsersAsyncStatusCode = error.status;
            this.$store.commit("setShowNotification", {
              type: "error",
              title: "ERROR",
              text: "Por favor verifica la información e intenta de nuevo"
            });
          });
      }
    },
    async saveField(field) {
      // check for empty fields
      if (
        this.selectedUser._id === "" ||
        typeof this.selectedUser._id === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "Ocurrió un error interno, por favor intenta de nuevo"
        });
        this.$router.replace("/users");

        return false;
      } else if (
        this.selectedUser.name === "" ||
        typeof this.selectedUser.name === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un nombre"
        });

        return false;
      } else if (
        this.selectedUser.role === "" ||
        typeof this.selectedUser.role === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha seleccionado un rol"
        });

        return false;
      } else if (
        this.selectedUser.email === "" ||
        typeof this.selectedUser.email === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado un correo"
        });

        return false;
      }

      // return field to a no edition view
      if (field == "name") {
        this.editName = false;
      } else if (field == "role") {
        this.editRole = false;
      } else if (field == "mail") {
        this.editMail = false;
      } else if (field == "password") {
        this.editPassword = false;
      } else if (
        !this.selectedUser.permission.createUser &&
        this.selectedUser._id === this.currentUser._id
      ) {
        if (!(await this.$refs.loseAccesModal.pop())) {
          this.selectedUser.permission.createUser = true;
          return false;
        }
      }

      // update originalUser
      this.originalUser = Object.assign({}, this.selectedUser);
      this.$store.commit("setIsLoadingState", true);
      // send request
      this.$store
        .dispatch("updateUser", field)
        .then(response => {
          this.$store.dispatch("getUser");
          this.$store.commit("setShowNotification", {
            type: "success",
            title: "Contacto actualizado",
            text: "La información se guardó con éxito"
          });
          this.$store.commit("setIsLoadingState", false);
          if (
            response.data.result.value.permission.createUser === false &&
            this.selectedUser._id === this.currentUser._id
          ) {
            this.$store.dispatch("setUser", response.data.result.value);
            this.currentUser = JSON.parse(
              localStorage.getItem("cedehm.org")
            ).user;
            this.$router.replace("/");
          } else {
            this.getUserList();
          }
        })
        .catch(error => {
          this.$store.commit("setIsLoadingState", false);
          this.$store.commit("setShowNotification", {
            type: "error",
            title: "ERROR",
            text: error.response.data.message
          });
        });
    },
    updatePassword() {
      if (
        this.selectedUser._id === "" ||
        typeof this.selectedUser._id === "undefined"
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "Ocurrió un error interno, por favor intenta de nuevo"
        });
        this.$router.replace("/users");
      } else if (
        this.selectedUser.password === "" ||
        typeof this.selectedUser.password === "undefined" ||
        this.selectedUser.password.length <= 6
      ) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "No se ha ingresado una contraseña de al menos 6 caracteres"
        });
      } else if (this.confirmPassword !== this.selectedUser.password) {
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "Las contraseñas no coinciden"
        });
      } else {
        // update originalUser
        this.originalUser = Object.assign({}, this.selectedUser);
        this.$store.commit("setIsLoadingState", true);
        // send request
        this.$store
          .dispatch("updatePassword")
          .then(() => {
            this.$store.commit("setShowNotification", {
              type: "success",
              title: "Contacto actualizado",
              text: "La contraseña se guardó con éxito"
            });
            this.editPassword = false;
            this.$store.commit("setIsLoadingState", false);
            this.getUserList();
          })
          .catch(() => {
            this.$store.commit("setIsLoadingState", false);
            this.$store.commit("setShowNotification", {
              type: "error",
              title: "ERROR",
              text: "Por favor verifica la contraseña e intenta de nuevo"
            });
          });
      }
    },
    async getUserList() {
      await this.$store.dispatch("getUserList");
      if (
        this.$store.state.getUsersAsyncStatusCode == 200 &&
        this.userList.length == 0
      ) {
        this.addUser();
      }
    },
    getUserInitials() {
      if(this.selectedUser.name) {
        let nameArray = this.selectedUser["name"].trim().split(' ')
        if (nameArray.length === 1)
         this.userInitials = `${nameArray[0].charAt(0)}`;
        else
          this.userInitials =  `${nameArray[0].charAt(0)}${nameArray[nameArray.length - 1].charAt(0)}`;
        return this.userInitials.toUpperCase()
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    uploadUserProfileImg(e) {
      this.getBase64(e.target.files[0]).then(fileData => {
        let imageData = {
          folio: this.selectedUser["_id"],
          file: fileData,
          descrip: "perfil",
          fileName: ""
        };
        this.$store.commit("setIsLoadingState", true);
        this.$store.dispatch("uploadImage", imageData)
          .then(response => {
            this.$store.state.userEdit.profileImg = response.data;
            this.$store.commit("setIsLoadingState", false);
          })
          .catch(() => {
            this.$store.commit("setIsLoadingState", false);
          });
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    deleteFoto() {
      let imageData = {
        id: this.selectedUser["_id"],
        file: require("@/assets/upload-icon.png")
      };
      this.$store.commit("setIsLoadingState", true);
      this.$store.dispatch("uploadImage", imageData)
        .then(response => {
          this.$store.state.userEdit.profileImg = response.data;
          this.$store.commit("setIsLoadingState", false);
        })
        .catch(() => {
          this.$store.commit("setIsLoadingState", false);
        });
    }
  },
  async mounted() {
    await this.getUserList();
    if (this.userList.length > 0) {
      let current = this.userList.filter(u => u.email == this.$store.state.user.email)[0];
      this.currentUser = current;
      this.selectUser(this.currentUser);
    };
  }
};
</script>
<style lang="scss" scoped>
#adminaccess {
  background-color: #f2f2f2;
  .container.container--fluid {
    padding: 50px !important;
  }

  .new-user {
    display: block;
    position: relative;
    bottom: 0;
    left: 20%;
  }

  .list-title {
    font-size: 24px;
    font-weight: 500;
    padding: 0px 17px;
  }

  .border-list {
    border-right: 2px solid #979797;
    position: relative;
    height: 400px;
    padding: 0px;
  }

  .info-container {
    padding: 0px 30px;
  }

  .white-btn.v-btn {
    font-size: 15px !important;
  }

  .main-color-button.v-btn {
    font-size: 15px !important;
    float: right;
  }

  .profile img {
    max-height: 230px;
    object-fit: contain;
  }

  .label-title {
    font-size: 13px;
    color: $main-color;
    font-weight: bold;
  }

  .field-title {
    color: $font-color-dark;
    font-size: 13px;
    &:hover {
      opacity: 0.9;
      cursor: pointer;
      .edit {
        opacity: 0.6;
      }
    }
  }
  .field-title.bold {
    font-size: 15px !important;
  }
  .user-name {
    font-size: 35px;
  }
  .small-font {
    font-size: 16px;
  }
  .delete {
    float: right;
    color: $font-color;
    cursor: pointer;
    width: fit-content;
    &:hover {
      cursor: pointer;
      opacity: 0.6;
    }
  }
  img {
    border-radius: 100%;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
    &:hover {
      cursor: pointer;
      opacity: 0.6;
    }
  }
  .edit {
    float: right;
    cursor: pointer;
    font-size: 18px;
    color: $font-color;
    &:hover {
      opacity: 0.6;
    }
  }
  .pswd {
    font-size: 13px;
  }
  .pswd:hover {
    text-decoration: underline;
    cursor: pointer;
  }
  .align-end {
    align-items: flex-end;
  }
  .form-group {
    padding: 0px !important;
  }
  .access-subtitle {
    font-size: 16.2px;
    font-weight: 500;
    color: $font-color;
  }
  h1 {
    font-size: 38px;
    font-weight: 500;
  }
  h2 {
    font-size: 33px;
  }
  h3 {
    font-size: 24px;
  }
  form {
    width: 100%;
    .access-form-control{
      width: 90%;
      border: none;
      border-radius: 5px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.18);
      padding-left: 0.8rem;
      background-color: #fff;
      font-family: 'Roboto', sans-serif;
      font-size: 15px;
      font-weight: bold;
      color: $font-color;
      .input-group__details {
        height: auto;
      }
    }
    .select {
      font-size: 16px;
      font-weight: bold;
      color: $font-color !important;
    }
  }
  .user-list {
    max-height: 55vh;
    overflow-y: scroll;
    //border-right: 1px solid #949494;
    .user.toggle-user,
    .user.toggle-user:hover {
      background-color:#4361ee99
    }
    .user {
      cursor: pointer;
      //overflow: hidden;
      text-overflow: ellipsis;
      padding: 8px 17px;
      &:hover {
        background-color: $main-color-light;
      }
    }
  }
  .permissions-container {
    padding-top: 0px;
  }
  .permissions {
    font-size: 25px;
  }
  .form-check-input {
    margin: 0px !important;
    padding: 0px !important;
    label {
      font-size: 12px !important;
      color: black;
    }
  }

  .end-row {
    justify-content: flex-end;
  }
  .avatar {
    width: 100%;
    position: relative;
    padding-bottom: 100%;
    background-color: #4361ee;
    border-radius: 50%;
  }
  .avatar-inside {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .initials {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 6vw;
    color: #fff;
    font-weight: bold;
  }
}
</style>
